module.exports = __webpack_public_path__ + "img/faces.10f76b99.svg";